export default __webpack_public_path__ + "static/media/provesional_restoration_upper_11_4@2x.00dbf952.png";